import React from "react";
import "./Button.css";

function Button({ 
  children, 
  type = "button", 
  variant = "primary", 
  size = "medium", 
  loading = false,
  disabled = false,
  fullWidth = false,
  className = "",
  onClick,
  ...props 
}) {
  const buttonClasses = [
    "btn",
    `btn-${variant}`,
    `btn-${size}`,
    fullWidth ? "btn-full-width" : "",
    loading ? "btn-loading" : "",
    className
  ].filter(Boolean).join(" ");

  return (
    <button
      type={type}
      className={buttonClasses}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading && (
        <span className="btn-spinner">
          <svg viewBox="0 0 24 24" className="spinner">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeDasharray="60" strokeDashoffset="60">
              <animate attributeName="stroke-dasharray" dur="2s" values="0 60;60 0" repeatCount="indefinite"/>
              <animate attributeName="stroke-dashoffset" dur="2s" values="0;-60" repeatCount="indefinite"/>
            </circle>
          </svg>
        </span>
      )}
      <span className={loading ? "btn-text-loading" : "btn-text"}>
        {children}
      </span>
    </button>
  );
}

export default Button;
